<!-- <div class="HP-container-video ht-part-bottom">
    <video src="../../assets/videos/gamele.mp4" 
        onloadedmetadata="this.muted = true"
        oncanplay="this.play()"
        width=100% 
        loop> 
    </video>
</div> -->
<div class="px-2">
    <div class="HP-part1 container mt-5 mb-5 px-0 pt-5 pb-5">
        <q class="HP-citation flex justify-center" cite="https://citations.ouest-france.fr/citation-charles-de-gaulle/entre-possible-impossible-deux-lettres-109635.html">
            "Commence où tu es,
            <span class="citationl2">utilise ce que tu as,</span>
            fais ce que tu peux."
        </q>
    </div>

    <div class="HP-part2 ht-grid container-lg mb-5 pb-5 px-0">
    <!--
        <h2 class="HP-h2 m-0">Nos prestations</h2>
    -->
        <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
            <div class="carousel-indicators">
                <button type="button"
                        data-bs-target="#carouselExampleIndicators"
                        data-bs-slide-to="0"
                        class="active"
                        aria-current="true"
                        aria-label="Slide 1">
                </button>
                <button type="button"
                        data-bs-target="#carouselExampleIndicators"
                        data-bs-slide-to="1"
                        aria-label="Slide 2">
                </button>
                <button type="button"
                        data-bs-target="#carouselExampleIndicators"
                        data-bs-slide-to="2"
                        aria-label="Slide 3">
                </button>
            </div>
            
            <!-- les images doivent être aux dimension paysage 2:3 -->
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <img src="assets/img/jordy-coaching.jpg" class="d-block w-100" alt="Jordan en train de coacher">
                </div>
                <div class="carousel-item">
                    <img src="assets/img/manon-bocal.jpg" class="d-block w-100" alt="photo de Manon la diététicienne">
                </div>
                <div class="carousel-item">
                    <img src="assets/img/cours-co.jpg" class="d-block w-100" alt="Cours collectif">
                </div>
            </div>
            <button class="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselExampleIndicators"
                    data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselExampleIndicators"
                    data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
            </button>
        </div>
        <div class="text-carousel flex flex-column justify-between">
            <div class="text-carousel-part">
                <p class="text-carousel-fat">Coaching personnalisé</p>
                <p class="text-carousel-light">Définissez vos objectifs avec un rendez-vous gratuit</p>
            </div>
            <div class="text-carousel-part">
                <p class="text-carousel-fat">Cours de cross-training</p>
                <p class="text-carousel-light">Grâce à votre abonnement mensuel</p>
            </div>
            <div class="text-carousel-part">
                <p class="text-carousel-fat">Diététicienne</p>
                <p class="text-carousel-light">Accélérez vos résultats</p>
            </div>
            <div class="text-carousel-part">
                <p class="text-carousel-fat">Presso-thérapie</p>
                <p class="text-carousel-light">Optimisez votre récupération</p>
            </div>
            <div class="text-carousel-part">
                <p class="text-carousel-fat">Small group club</p>
                <p class="text-carousel-light">Améliorez votre pré-saison</p>
            </div>
        </div>
    </div>

    <div class="HP-part3 container-lg mb-5 pb-5 px-0">
        <app-list-articles></app-list-articles>
    <!--
        <h2 class="HP-h2 m-0">Nos derniers articles de blog</h2>
    -->
        <!-- <div class="container-article-summary" *ngFor="let article of articles">
            <app-article-summary [article]="article"></app-article-summary>
        </div> -->
        <a routerLink="/blog" class="link-vers-blog">
            <button type="button" class="btn btn-lg btn-block">
                Voir tous les articles
            </button>
        </a>
    </div>

    <div class="HP-part4 container-lg ht-part-bottom px-0">
    <!--
        <h2 class="HP-h2 m-0">Où nous trouver ?</h2>
    -->
        <app-map class="ht-grid"></app-map>
    </div>
</div>